export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13616.42967149.jpg";